<!--源泉徴収票-->
<template>
  <div>
    <!-- 表头文字 -->
    <el-row style="text-align:left;">
      <el-col>
        <p class="d0001_info">{{$t('MODULE.K0013_LBL_MESSAGE')}}</p>
      </el-col>
    </el-row>
    <table class="table_d0001" style="border-collapse:collapse;">
      <!--タイトル-->
      <tr class="d0001_table_title">
        <td class="d0001_table_header" style="border-right:1px solid #dfdfdf ;width:20%;">{{$t('MODULE.K0013_LBL_TITTLE')}}</td>
        <!--ファイル名-->
        <td class="d0001_table_header" style="border-right:1px solid #dfdfdf ;width:40%;">{{$t('MODULE.K0013_LBL_FILE')}}</td>
        <!--メモ-->
        <td class="d0001_table_header" style="border-left:1px solid #dfdfdf ;border-right:1px solid #dfdfdf ;width:40%;">{{$t('MODULE.K0013_LBL_MEMO')}}</td>
      </tr>
      <tr class="d0001_table_list">
        <!--源泉徴収票-->
        <td class="input_d0001_table" style="border-left:1px solid #dfdfdf ;border-bottom:1px solid #dfdfdf ;border-right:1px solid #dfdfdf ;width:20%;">test</td>
        <!-- 文件下载LINK -->
        <td class="input_d0001_table" style="border-bottom:1px solid #dfdfdf ;border-right:1px solid #dfdfdf ;width:40%;">
          <a href="/static/test.pdf" @click="PdfDnld" download="test.pdf">test</a>
        </td>
        <!-- メモ -->
        <td class="input_d0001_table" style="border-bottom:1px solid #dfdfdf ;border-right:1px solid #dfdfdf ;width:40%;">test</td>
      </tr>
    </table>
  </div>
</template>
<script>
export default {
  data() {
    return {

    }
  },
  methods: {
    PdfDnld() {

    }
  }
}
</script>
<style>
/*表头文字尺寸 */
.d0001_info {
  font-size: 10pt;
}
/* 表头样式 */
.d0001_table_title {
  background-image: linear-gradient(#3cc6fa, #1197ca);
  width: 100%;
  height: 30px;
  overflow: hidden;
  margin: 0px;
  border: 0;
  padding: 0;
  text-align: center;
}
/* 列表样式 */
.d0001_table_list {
  width: 100%;
  height: 30px;
  word-break: break-all; /*文字过多自动换行*/
  overflow: hidden;
  margin: 0px;
  border: 0;
  padding: 0;
  text-align: center;
}
/* 上半部td样式 */
.d0001_table_header {
  padding: 0px 0px 0px 0px;
  height: 30px;
  min-height: 30px;
  color: #ffffff;
  width: 100%;
  font-weight: bold;
}
/* 下半部td样式 */
.input_d0001_table {
  padding: 0px 0px 0px 0px;
  height: 30px;
  min-height: 30px;
  color: #666;
  width: 100%;
  font-weight: bold;
  text-align: center;
}
/* 表尺寸 */
.table_d0001 {
  width: 100%;
  height: 100%;
  font-size: 10pt;
}
</style>



// WEBPACK FOOTER //
// src/module/page/d_0001.vue